<template>
  <div class="py-5 text-center">
    <div class="container">
      <h1 class="who-is fw-light text-dark animated fadeIn">{{ $t('ours') }} <b>Playlists</b></h1>
      <div class="playlist-description fw-light animated fadeInUp pb-3">
        <span v-html="$t('follow_our_playlists')"></span><br/>
      </div>
      <div class="row animated fadeIn mt-5">
        <div class="col-md-4 mb-4" v-for="(playlist, index) in playlists" v-bind:key="`playlist_${index}`">
          <div>
            <h2 class="h3">{{ playlist.name }}</h2>
          </div>
          <div class="mt-2">
            <iframe :src="`https://open.spotify.com/embed/playlist/${playlist.id}`" width="100%" height="400" frameborder="0" allowtransparency="true" class="block" allow="encrypted-media"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import Public from '../services/public'

export default {
  name: 'LandingAbout',
  data: function () {
    return {
      playlists: []
    }
  },
  created: function () {
    Public.getPlaylists().then(response => {
      this.playlists = _.filter(response.data, item => {
        return item.tracks.total > 5
      })
    })
  },
  mounted: function () {
    window.document.title = this.$t('landing_playlists')
    window.$('meta[property="og:title"]').attr('content', this.$t('landing_playlists'))
    window.$('meta[name="description"]').attr('content', this.$t('landing_playlists_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('landing_playlists_description'))

    setTimeout(() => {
      window.prerenderReady = true
    }, 1000)
  }
}
</script>
<style lang="scss" scoped>
.who-is {
  font-size: 4em;
}

.playlist-description {
  font-size: 1.5em;
}

a {
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LandingPlaylists.vue